// Module
var code = `<div class="{{.cssClass}}{{#.haveError}} js-tercera-lookup-error{{/}}{{#if isFormShowed}} active{{/if}}"
     style="{{>visibility}}; {{#if isPosAbsolute}}position: absolute; z-index: {{.zIndex}}; {{>position}}{{/if}}"
     on-mousedown="@this.onMouseDown(event)"
     {{>visualparameters}}>
    {{#if .isInstrumentLookup}}
        <terceraInstrumentLookupTextBox name="lookupTB" enabled="{{.enabled}}" isReadOnly="{{.isReadOnly}}" instrTypeImgConst="{{.instrTypeImgConst}}" currentInstrument="{{.selectedItem}}" selectedAccount="{{.selectedAccount}}" isSymbolInfoOpened="{{isSymbolInfoOpened}}" />
    {{else}}
        <terceraTextBox name="lookupTB" enabled="{{.enabled}}" isReadOnly="{{.isReadOnly}}" visible="{{.tbIsVisible}}" />
    {{/if}}
    <terceraButton name="{{.btnName}}" terceraButtonStyle="{{.btnClass}}"
                   enabled="{{.enabled}}"
                   SVG="true"
                   tooltip="{{.btnTooltip}}"
                   on-btnClick='lookupBtnClick'
                   showDisabledToolTip="{{showDisabledToolTip}}"
                   canCheck="true"
                   checked="{{isFormShowed}}"/>
</div>`;
// Exports
export default code;